import { combineReducers } from "redux";
import { appReducer } from "./app";
import { cacheReducer } from "./cache";

export const rootReducer = combineReducers({
  app: appReducer,
  cache: cacheReducer,
});
